const isScrollLocked = () => typeof document !== 'undefined' && [document.body, document.documentElement].some(element => element.style.overflow === 'hidden');
export default isScrollLocked;